/** @jsx jsx */
import { jsx } from '@emotion/react';

import { isUndefined } from 'lodash';
import { compose } from 'recompose';

import type { TrackingData } from 'js/lib/retracked';

import SkillCard, { SkillCardPlaceholder } from 'bundles/program-home/components/myLearning/skillsDashboard/SkillCard';
import withSkillScore from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/withSkillScore';
import type {
  PropsFromCaller,
  PropsFromSkillScoreGraphql,
} from 'bundles/program-skills-objectives/components/ProgramSkillRecommendationsPage/withSkillScore';

type PropsFromParent = {
  className?: string;
  skillId: string;
  skillName: string;
  trackingData: TrackingData;
  programSlug: string;
  currentRefinement: string | undefined;
};
type Props = PropsFromParent & PropsFromCaller & PropsFromSkillScoreGraphql;

const SkillCardWithScore = ({
  loadingScore,
  skillScore,
  className,
  skillId,
  skillName,
  trackingData,
  programSlug,
  currentRefinement,
}: Props) => {
  if (loadingScore) {
    return <SkillCardPlaceholder className={className} />;
  } else {
    return (
      <SkillCard
        size="small"
        className={className}
        skill={{
          skillId,
          skillName,
          score: skillScore ?? 0,
          isEligibleForScoring: !isUndefined(skillScore),
          // This are all hardcoded default values, unnecesary for the search banner
          domains: [],
          scoredAtTime: 0,
          levelsetStatus: 'UNAVAILABLE',
        }}
        currentRefinement={currentRefinement}
        trackingData={trackingData}
        trackingName="search_banner_skill_card"
        source="search_banner_skill_card"
        programSlug={programSlug}
      />
    );
  }
};

export { SkillCardWithScore };
export default compose<Props, PropsFromParent & PropsFromCaller>(withSkillScore)(SkillCardWithScore);
